export default {
    title: 'Notifikacioni centar',
    select: {
        allNotifications: 'Sve notifikacije'
    },
    leftReview: 'je ostavio/la ocjenu',
    leftComment: 'je komentarisao/la',
    user: 'Korisnik',
    buyer: 'Kupac',
    store: 'Prodavnica',
    product: 'Proizvod',
    yourStore: 'Vaša prodavnica je',
    verified: 'verifikovana',
    refundRequest: 'Zahtjev za refundaciju proizvoda',
    inTheAmount: 'u iznosu od',
    cardPayment: 'Zahtjev za opciju naplate kreditnom karticom je',
    is: 'je',
    enabled: 'odobren.',
    approved: 'odobren.',
    denied: 'odbijen.',
    cardEnable: 'Plaćanje možete ukljućiti',
    here: 'ovdje',
    hasChangedStatus: 'je promijenio/la status naružbine broj',
    storeHasChangedStatus: 'je promijenila status naružbine broj',
    createOrder: 'Narudžbina je kreirana. Broj narudžbine: ',
    orderNumber: 'Broj narudžbine: ',
    hasAcceptedInvitation: 'je prihvatio/la poziv za Vašu prodavnicu',
    becameUnavailable: 'je postao nedostupan. Broj zaliha u inventaru je pao na 0.',
    deliveredOrder: 'Vam je nedavno dostavila narudžbinu broj',
    remindToReview: 'Ne zaboravite da ocijenite proizvode.',
    table: {
        header: {
            title: 'Notifikacija'
        },
        answerButton: 'Odgovori',
        seeButton: 'Pogledaj'
    },
    modal: {
        successMessage: 'Odgovor uspješno postavljen.',
        comment: {
            title: 'Komentar',
            buyer : {
                message: 'je komentarisao/la i ostavio/la ocjenu za proizvod:',
                textarea: {
                    title: 'Ostavite odgovor',
                },
                optional: 'opciono',
                button: {
                    close: 'Zatvori',
                    answer: 'Odgovori'
                }
            },
            seller: {
                message: {
                    text1: 'Prodavnica',
                    text2: 'je komentarisao/la i ostavio/la ocjenu za proizvod:',
                    text3: 'je odgovorila na Vaš komentar za proizvod:'
                },
                textarea: {
                    title: 'Ostavite odgovor',
                },
                optional: 'opciono',
                button: {
                    close: 'Zatvori',
                    see: 'Pogledaj',
                    answer: 'Odgovori'
                }
            }

        },

    }
}
